module.exports = __webpack_public_path__ + "img/step1.22bbc92e.png";